import React from "react";
import styled from "styled-components";
import travlogyLoader from "assets/common/gif/travlogy_loader.gif";

const SplashScreen = () => {
    return(
        <RootContainer>
            <img src={travlogyLoader} />
        </RootContainer>
    );
};

export default SplashScreen;

const RootContainer = styled.div`
position: relative;
width: 100%;
height: 100vh;
margin: 0;
padding: 0;
box-sizing: border-box;
display: flex;
justify-content: center;
align-items: center;
img {
    max-height: 400px;
    max-width: 100%;
}
`;
